import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import {
  FaCloudDownloadAlt,
  FaDownload,
  FaFileDownload,
  FaLink,
  FaPlay,
} from "react-icons/fa";
import { useDispatch, useSelector } from "react-redux";
import { fetchStocks } from "../slices/stocksSlice";


import config from "../common/config"

const StocksData = () => {
  const dispatch = useDispatch();
  const { stocks, status, error } = useSelector((state) => state.stocks);

  useEffect(() => {
    if (status === "idle") {
      dispatch(fetchStocks());
    }
  }, [status, dispatch]);

  if (status === "loading") {
    return <div>در حال بارگذاری اطلاعیه‌ها...</div>;
  }

  if (status === "failed") {
    return <div>خطا در بارگذاری: {error}</div>;
  }

  return (
    <>
      {/* Transport service area start */}
      <div className="transport-service-area">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="section-title text-center">
                <span className="subtitle">سهام و مجامع</span>
                <h2 className="title">اطلاعیه سهامداران</h2>
              </div>
            </div>
          </div>

          {stocks.map((stock, index) => (
            <div
              key={stock.id}
              className={`row transport-service-single ${
                index % 2 === 0 ? "" : "flex-row-reverse"
              }`}
            >
              <div className="col-lg-6">
                <div
                  className={`transport-service-image wow ${
                    index % 2 === 0 ? "fadeInLeft" : "fadeInRight"
                  }`}
                >
                  <img
                    src={`${config.baseImageUrl}/${stock.imagePath}`}
                    className="img-fluid"
                    alt="transport-service images"
                  />
                  <div className="transport-service-item-hover">
                    <Link to={stock.fileOrLinkPath} target="_blank">
                      <div className="stock-thumb-wrap">
                        <span className="stock-play-btn cursor-pointer">
                          {stock.type === "File" && <FaFileDownload />}
                          {stock.type === "Link" && <FaLink />}
                          {stock.type === "Live" && <FaPlay />}
                        </span>
                      </div>
                    </Link>
                  </div>
                </div>
              </div>
              <div className="col-lg-4 offset-lg-1 d-flex">
                <div
                  className={`transport-service-content wow ${
                    index % 2 === 0 ? "fadeInRight" : "fadeInLeft"
                  }`}
                >
                  <h5 className="title">{stock.title}</h5>
                  <p>{stock.description}</p>
                  <div className="btn-wrapper text-left">
                    {stock.type === "File" && (
                      <Link
                        to={stock.fileOrLinkPath}
                        target="_blank"
                        className="boxed-btn blank"
                      >
                        دریافت فایل
                      </Link>
                    )}
                    {stock.type === "Link" && (
                      <Link
                        to={stock.fileOrLinkPath}
                        target="_blank"
                        className="boxed-btn blank"
                      >
                        مشاهده لینک
                      </Link>
                    )}
                    {stock.type === "Live" && (
                      <Link
                        to={stock.fileOrLinkPath}
                        target="_blank"
                        className="boxed-btn blank"
                      >
                        پخش زنده
                      </Link>
                    )}
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
      {/* Transport service area end */}
    </>
  );
};

export default StocksData;
